package com.starparty.app.astro0

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class SP_Place {
   // Default Greenwich Royal Observatory
   // var latitude = 51.476853
   // var longitude = -5.002E-4

    // Default Sennen Cove
   /* var latitude: Double = UMS.unitMinSecToDecimal("50 4 40")
    var longitude: Double = UMS.unitMinSecToDecimal("-5 42 12") */

    // Default Greenwich Royal Observatory
     var latitude = 50.0756
     var longitude = -5.7030

    constructor() {
    }

    constructor(lat: Double, lon: Double) {
        latitude = lat
        longitude = lon
    }

}